import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-top: 24px;
    padding-bottom: 24px;

    .close {
        position: absolute;
        right: 10px;
        top: 24px;
        
        button {
            background-color: transparent;
            outline: none;
            cursor: pointer;
            border: none;
            align-self: center;
            box-sizing: border-box;

            .i-close {
                vertical-align: middle;
                align-self: center;
                font-size: 24px;
                top: 24px;
                right: 10px;
                color: #c0b7b8 !important;
            }
        }
    }

        span {
                color: #2a0709;
                font-weight: 600
            }

            hr {
                display: block;
                width: 99%;
                border-top: 1px solid #f3f3f3;
                margin: auto;
                margin-top: 32px;
                margin-bottom: 32px;
            }

                h2 {
                    width: 100%;
                    text-align: center;
                    margin: 0;
                    font-family: Montserrat;
                    font-size: 11px;
                    color: #a49b9b;
                    font-weight: 400
                }

            .div-restaurante {
                width: 90%;

                .status-aberto {
                    cursor: context-menu;
                    outline: none;
                    width: 100%;
                    margin-top: 32px;
                    display: flex;
                    height: 42px;
                    border-radius: 50px;
                    background-color: #dcead3;
                    border: 1.5px solid #4e9721;
                    align-items: center;
                    justify-content: center;

                    .statusText {
                        align-self: center;
                        text-align: center;
                        color: #4e9721;
                        font-family: Montserrat;
                        font-size: 11px;
                        font-weight: 700;
                    }
                }

                .status-fechado {
                    cursor: context-menu;
                    outline: none;
                    width: 100%;
                    margin-top: 32px;
                    display: flex;
                    height: 42px;
                    border-radius: 50px;
                    background-color: #f3d1d4;
                    border: 1.5px solid #c32027;
                    align-items: center;
                    justify-content: center;

                    .statusText {
                        align-self: center;
                        text-align: center;
                        color: #c32027;
                        font-family: Montserrat;
                        font-size: 11px;
                        font-weight: 700;
                    }
                }
            }

    .restaurante {
            margin-top: 32px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 90%;

            .perfil {
                overflow: hidden;
                object-fit: cover;
                border-radius: 100px;
                width: 40px;
                height: 40px;
            }

            .texto {
                display: flex;
                flex-direction: column;
                margin-left: 16px;
                justify-content: space-evenly;

                .ola {
                    margin: 0px;
                    font-family: Montserrat;
                    font-size: 14px;
                    color: #a49b9b;
                    font-weight: 400
                }

                .rest {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin-top: 2px;

                    .nome {
                        margin: 0;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 600;
                        color: #2a0709;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2; /* number of lines to show */
                        -webkit-box-orient: vertical;
                    }
                }
            }
        }

    h1 {
        padding: 0;
        font-family: Montserrat;
        align-self: flex-start;
        font-size: 16px;
        font-weight: 700;
        text-align: left;
        color: #000000;
    }

    .div-sair {
        width: 90%;

        .buttons {
            width: 100%;
            display: flex;
            flex-direction: column;

            button {
                cursor: pointer;
                font-family: Montserrat;
                font-size: 11px;
                font-weight: 700;
                outline: none;
                border-radius: 100px;
                width: 100%;
                height: 42px;
            }

            .senha {
                border: none;
                background-color: #c32027;
                color: #fff;
                margin-top: 24px;
                margin-bottom: 8px;

                :hover {
                    background-color: #9c1a1f
                }

                :active {
                    background-color: #d7232c
                }
            }

            .sair {
                border: 1.5px solid #c32027;
                color: #c32027;
                background-color: #fff;

                :hover {
                    background-color: #faf8f8
                }

                :active {
                    background-color: #dedede
                }
            }
        }
    }
`